"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

exports.FormContainer = function (_a) {
  var children = _a.children,
      activeBreakpoint = _a.activeBreakpoint;

  if (responsive_1.isExtraLarge(activeBreakpoint)) {
    return react_1.default.createElement(react_native_1.View, null, children);
  }

  return react_1.default.createElement(react_1.default.Fragment, null, children);
};

exports.default = responsive_1.withResponsiveMeta(exports.FormContainer);